<!-- Toolbar -->
<div class="camx-bar px-2 px-sm-3 py-2 border-bottom flex-shrink-0">
  <span *ngIf="active" class="camx-hint me-auto">🔐 {{ 'ADMIN_CAMS_TOTP_LOGIN' | translate }}</span>
  <span *ngIf="!active" class="me-auto"></span>
  <button type="button" class="btn btn-sm btn-outline-secondary m-touch-sm" (click)="refresh()"
          [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
</div>

<div class="camx-scroll p-2 p-sm-3">

  <div *ngIf="statusError" class="alert alert-danger py-1 px-2 small mb-2">{{ 'ADMIN_CAMS_ERROR' | translate:{ msg: statusError } }}</div>
  <div *ngIf="!status && !statusError" class="text-muted small text-center py-4">{{ 'ADMIN_CAMS_LOADING' | translate }}</div>

  <!-- ═══ Configuration (what is set / missing) ═══ -->
  <div *ngIf="status" class="card mb-3">
    <div class="card-body p-2 p-sm-3 camx-small">
      <button type="button" class="camx-toggle" [class.open]="cfgOpen" [attr.aria-expanded]="cfgOpen" (click)="cfgOpen = !cfgOpen">
        <span class="camx-chev">▸</span>
        <span class="camx-card-title me-auto">{{ 'ADMIN_CAMS_CONFIG' | translate }}</span>
        <span class="badge" [ngClass]="cfgComplete ? 'text-bg-success' : 'text-bg-warning'">
          {{ (cfgComplete ? 'ADMIN_CAMS_CFG_COMPLETE' : 'ADMIN_CAMS_CFG_INCOMPLETE') | translate }}
        </span>
      </button>

      <ng-container *ngIf="cfgOpen">
        <div class="camx-kv mt-2">
          <ng-container *ngFor="let row of cfgRows; trackBy: trackCfg">
            <div>
              <div>{{ row.label }}</div>
              <div class="camx-env">{{ row.env }}</div>
            </div>
            <div [class.text-success]="row.ok"
                 [class.text-warning-emphasis]="!row.ok && row.warn"
                 [class.text-danger]="!row.ok && !row.warn">{{ row.ok ? '✓' : row.warn ? '⚠' : '✗' }} {{ row.value }}</div>
          </ng-container>
        </div>
        <ul *ngIf="problems.length" class="small text-warning-emphasis mt-2 mb-0 ps-3" style="word-break:break-word;">
          <li *ngFor="let p of problems">{{ p }}</li>
        </ul>
        <div *ngIf="!cfgComplete" class="camx-hint mt-2">
          {{ 'ADMIN_CAMS_MISSING_HINT' | translate }} {{ 'ADMIN_CAMS_FAIL_CLOSED' | translate }}
        </div>
      </ng-container>

      <!-- Certificate fingerprint seen by the TLS probe (no pin set, or not matching it) -->
      <div *ngIf="pinObserved" class="mt-2 pt-2 border-top">
        <div *ngIf="pinMismatch" class="alert alert-danger py-1 px-2 small mb-2" role="alert">⚠ {{ 'ADMIN_CAMS_FP_MISMATCH' | translate }}</div>
        <div class="fw-semibold mb-1">{{ 'ADMIN_CAMS_FP_TITLE' | translate }}</div>
        <div class="d-flex gap-2 align-items-start">
          <div class="camx-fp flex-grow-1">{{ pinObserved }}</div>
          <button type="button" class="btn btn-sm btn-outline-secondary flex-shrink-0 text-nowrap m-touch-sm"
                  (click)="copy(pinObserved, 'fp')">{{ (copied === 'fp' ? 'KOPIERT' : 'ADMIN_CAMS_COPY') | translate }}</button>
        </div>
        <div class="camx-hint mt-1">{{ 'ADMIN_CAMS_FP_HINT' | translate:{ url: protectUrl } }}</div>
      </div>
    </div>
  </div>

  <!-- ═══ No second factor on the admin login: no camera data (fail closed) ═══ -->
  <div *ngIf="status && !totpConfigured" class="card mb-3">
    <div class="card-body p-3 text-center">
      <div style="font-size:2rem;line-height:1.2;">🔒</div>
      <div class="fw-semibold mb-1">{{ 'ADMIN_CAMS_NO_TOTP_TITLE' | translate }}</div>
      <div class="small text-body-secondary mx-auto" style="max-width:420px;">{{ 'ADMIN_CAMS_NO_TOTP' | translate }}</div>
    </div>
  </div>

  <!-- ═══ Snapshot grid (session with TOTP login) ═══ -->
  <ng-container *ngIf="active">
    <div *ngIf="camsError" class="alert alert-danger py-1 px-2 small mb-2">{{ 'ADMIN_CAMS_ERROR' | translate:{ msg: camsError } }}</div>
    <div *ngIf="!camsLoaded && !camsError" class="text-muted small text-center py-4">{{ 'ADMIN_CAMS_LOADING' | translate }}</div>
    <div *ngIf="camsLoaded && !tiles.length" class="text-muted small text-center py-3">{{ 'ADMIN_CAMS_GRID_EMPTY' | translate }}</div>

    <div *ngIf="tiles.length" class="camx-grid mb-2">
      <button *ngFor="let t of tiles; trackBy: trackTile" type="button" class="camx-tile" [title]="t.name" (click)="openLarge(t)">
        <div class="camx-frame">
          <img *ngIf="t.url && !t.offline" [src]="t.url" [alt]="t.name" draggable="false">
          <div *ngIf="!t.url || t.offline" class="camx-ph">
            <span class="camx-ph-icon">{{ t.offline ? '🚫' : t.error ? '⚠️' : '📷' }}</span>
            <span>{{ (t.offline ? 'ADMIN_CAMS_OFFLINE' : t.error ? 'ADMIN_CAMS_NO_IMAGE' : 'ADMIN_CAMS_LOADING') | translate }}</span>
          </div>
          <span *ngIf="t.url && !t.offline && t.at" class="camx-age">{{ t.at }}</span>
        </div>
        <div class="camx-cap">
          <span class="camx-name">{{ t.name }}</span>
          <span class="badge camx-state" [ngClass]="stateCls(tileState(t))">{{ stateLabel(tileState(t)) }}</span>
        </div>
        <div *ngIf="t.error" class="camx-err">{{ t.error }}</div>
      </button>
    </div>
    <div class="camx-hint mb-3">🔒 {{ 'ADMIN_CAMS_RAM_ONLY' | translate }}</div>

    <!-- All cameras: help choosing CAMS_ALLOWLIST (no images) -->
    <div class="card mb-3">
      <div class="card-body p-2 p-sm-3 camx-small">
        <button type="button" class="camx-toggle" [class.open]="allOpen" [attr.aria-expanded]="allOpen" (click)="toggleAll()">
          <span class="camx-chev">▸</span>
          <span class="camx-card-title me-auto">{{ 'ADMIN_CAMS_ALL' | translate }}</span>
          <span *ngIf="allRows.length" class="camx-hint">{{ allRows.length }}</span>
        </button>
        <ng-container *ngIf="allOpen">
          <div class="d-flex align-items-start gap-2 mt-2">
            <div class="camx-hint me-auto">{{ 'ADMIN_CAMS_ALL_HINT' | translate }}</div>
            <button type="button" class="btn btn-sm btn-outline-secondary flex-shrink-0 m-touch-sm" (click)="fetchAll()"
                    [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
          </div>
          <div *ngIf="allError" class="alert alert-danger py-1 px-2 small mt-2 mb-0">{{ 'ADMIN_CAMS_ERROR' | translate:{ msg: allError } }}</div>
          <div *ngIf="allLoading && !allRows.length" class="text-muted small text-center py-3">{{ 'ADMIN_CAMS_LOADING' | translate }}</div>
          <div *ngIf="!allLoading && !allError && !allRows.length" class="text-muted small text-center py-3">{{ 'ADMIN_CAMS_NO_CAMERAS' | translate }}</div>
          <div class="camx-list mt-1">
            <label *ngFor="let r of allRows; trackBy: trackAll" class="camx-row mb-0">
              <input type="checkbox" class="form-check-input" [checked]="r.selected" (change)="toggleSelect(r)">
              <span class="flex-grow-1" style="min-width:0;">
                <span class="d-flex flex-wrap align-items-center gap-1">
                  <span class="fw-semibold text-break">{{ r.name }}</span>
                  <span class="badge camx-state" [ngClass]="stateCls(r.c.state)">{{ stateLabel(r.c.state) }}</span>
                  <span *ngIf="r.c.allowlisted" class="badge camx-state text-bg-primary">{{ 'ADMIN_CAMS_ALLOWLISTED' | translate }}</span>
                </span>
                <span *ngIf="r.c.type" class="d-block camx-hint">{{ r.c.type }}</span>
                <span class="d-block camx-id">{{ r.c.id }}</span>
              </span>
            </label>
          </div>
          <div *ngIf="allRows.length" class="mt-2">
            <div class="d-flex gap-2 align-items-start">
              <div class="camx-envline flex-grow-1">{{ allowlistLine }}</div>
              <button type="button" class="btn btn-sm btn-outline-secondary flex-shrink-0 text-nowrap m-touch-sm"
                      (click)="copy(allowlistLine, 'allow')">{{ (copied === 'allow' ? 'KOPIERT' : 'ADMIN_CAMS_COPY') | translate }}</button>
            </div>
            <div *ngIf="allowlistEmpty" class="camx-hint mt-1">{{ 'ADMIN_CAMS_NONE_SELECTED' | translate }}</div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Audit (in-memory ring on the backend) -->
    <div class="card mb-3">
      <div class="card-body p-2 p-sm-3 camx-small">
        <button type="button" class="camx-toggle" [class.open]="auditOpen" [attr.aria-expanded]="auditOpen" (click)="toggleAudit()">
          <span class="camx-chev">▸</span>
          <span class="camx-card-title me-auto">{{ 'ADMIN_CAMS_AUDIT' | translate }}</span>
          <span *ngIf="auditOpen && auditRows.length" class="camx-hint">{{ auditRows.length }}</span>
        </button>
        <ng-container *ngIf="auditOpen">
          <div class="d-flex align-items-start gap-2 mt-2">
            <div class="camx-hint me-auto">{{ 'ADMIN_CAMS_AUDIT_HINT' | translate }}</div>
            <button type="button" class="btn btn-sm btn-outline-secondary flex-shrink-0 m-touch-sm" (click)="fetchAudit()"
                    [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
          </div>
          <div *ngIf="auditError" class="alert alert-danger py-1 px-2 small mt-2 mb-0">{{ 'ADMIN_CAMS_ERROR' | translate:{ msg: auditError } }}</div>
          <div *ngIf="auditLoading && !auditRows.length" class="text-muted small text-center py-3">{{ 'ADMIN_CAMS_LOADING' | translate }}</div>
          <div *ngIf="!auditLoading && !auditError && !auditRows.length" class="text-muted small text-center py-3">{{ 'ADMIN_CAMS_AUDIT_EMPTY' | translate }}</div>
          <div class="camx-list camx-audit mt-1">
            <div *ngFor="let a of auditRows; trackBy: trackAudit" class="camx-row">
              <span class="text-nowrap" style="font-variant-numeric:tabular-nums;" [title]="a.full">{{ a.time }}</span>
              <span class="badge camx-state" [ngClass]="a.cls">{{ a.label }}</span>
              <span *ngIf="a.ip" class="mono text-break">{{ a.ip }}</span>
              <span *ngIf="a.session" class="camx-id" [title]="'ADMIN_CAMS_AUDIT_SESSION' | translate">#{{ a.session }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<!-- ═══ Large view (hq=1, refreshes every 1.5 s; the grid pauses meanwhile) ═══ -->
<div *ngIf="large as l" class="camx-large" role="dialog" aria-modal="true" [attr.aria-label]="l.tile.name" (click)="closeLarge()">
  <div class="camx-large-head" (click)="$event.stopPropagation()">
    <!-- Phones: the name above its state and time, so the name keeps most of the row -->
    <div class="camx-large-title">
      <span class="camx-name">{{ l.tile.name }}</span>
      <span class="camx-large-meta">
        <span class="badge camx-state" [ngClass]="stateCls(l.offline ? tileState(l.tile, true) : l.tile.cam.state)">{{ stateLabel(l.offline ? tileState(l.tile, true) : l.tile.cam.state) }}</span>
        <span *ngIf="l.at" class="small text-white-50 text-nowrap" style="font-variant-numeric:tabular-nums;">{{ l.url ? 'HQ · ' : '' }}{{ l.at }}</span>
      </span>
    </div>
    <app-link-button btnClass="btn-outline-light m-touch"></app-link-button>
    <button type="button" class="btn btn-sm btn-outline-light m-touch" (click)="closeLarge()"
            [title]="'ADMIN_CAMS_CLOSE' | translate" [attr.aria-label]="'ADMIN_CAMS_CLOSE' | translate">✕</button>
  </div>
  <div class="camx-large-body">
    <img *ngIf="!l.offline && (l.url || l.tile.url)" [src]="l.url || l.tile.url" [alt]="l.tile.name" draggable="false">
    <div *ngIf="l.offline || !(l.url || l.tile.url)" class="camx-ph">
      <span class="camx-ph-icon">{{ l.offline ? '🚫' : '📷' }}</span>
      <span>{{ (l.offline ? 'ADMIN_CAMS_OFFLINE' : 'ADMIN_CAMS_LOADING') | translate }}</span>
    </div>
  </div>
  <div *ngIf="l.error" class="small text-danger-emphasis px-3 pb-2" (click)="$event.stopPropagation()">{{ l.error }}</div>
</div>
